{
  "patient": {
    "_id": "",
    "firstName": "",
    "lastName": "",
    "gender": "",
    "dateOfBirth": "",
    "biography": "",
    "diagnosis": "",
    "avatar": [""],
    "wordsets": [],
    "sentencesets": [],
    "textsets": [],
    "code": "",
    "activeSentenceset": null,
    "activeTextset": null,
    "activeWordsets": [],
    "activeSentencesets": [],
    "activeTextsets": [],
    "audioSpeedSetting": "langsam",
    "active": true,
    "dailyPracticeDurationGoal": 60,
    "activateDailyGoal": true,
    "exerciseTypes": [],
    "exercises": [
      {
        "name": "Understanding",
        "iconName": "ear-outline",
        "iconLibrary": "Ionicons"
      },
      {
        "name": "Speaking",
        "iconName": "bubble",
        "iconLibrary": "SimpleLineIcons"
      },
      {
        "name": "Reading",
        "iconName": "book-open",
        "iconLibrary": "SimpleLineIcons"
      },
      {
        "name": "Writing",
        "iconName": "pencil-outline",
        "iconLibrary": "Ionicons"
      }
    ],
    "wordsetExerciseTypes": [
      {
        "setting": "related",
        "value": 4,
        "_id": "",
        "name": "Verstehen"
      },
      {
        "setting": "record",
        "value": 13,
        "_id": "",
        "name": "Sprechen"
      },
      {
        "setting": "gap",
        "value": 1,
        "_id": "",
        "name": "Schreiben"
      },
      {
        "setting": "related",
        "value": 4,
        "_id": "",
        "name": "Lesen"
      }
    ],
    "sentencesetExerciseTypes": [
      {
        "setting": "related",
        "value": 4,
        "_id": "",
        "name": "Verstehen"
      },
      {
        "setting": "record",
        "value": 5,
        "_id": "",
        "name": "Sprechen"
      },
      {
        "setting": "anagram",
        "value": 2,
        "_id": "",
        "name": "Schreiben"
      },
      {
        "setting": "related",
        "value": 4,
        "_id": "",
        "name": "Lesen"
      }
    ],
    "textsetExerciseTypes": [
      {
        "setting": "closed",
        "value": 4,
        "_id": "",
        "name": "Verstehen"
      },
      {
        "setting": "questions",
        "value": 600,
        "_id": "",
        "name": "Sprechen"
      },
      {
        "setting": "gap",
        "value": 0,
        "_id": "",
        "name": "Schreiben"
      },
      {
        "setting": "open",
        "value": 2,
        "_id": "",
        "name": "Lesen"
      }
    ],
    "created": "2021-01-26T12:03:02.098Z",
    "user": "",
    "__v": 3
  },
  "sets": [
    {
      "type": "wordset",
      "setItems": [
        {
          "_id": "",
          "__v": 0,
          "type": "word",
          "word": {
            "_id": "",
            "__v": 6,
            "created": "2016-10-25T11:08:43.954Z",
            "grapheme": "ei",
            "print": "Ei",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0d423a7d-ce8a-4136-a002-cab2d617178f.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/f35ab5fe-aaeb-42ed-91e2-bf90647e6799.mp4",
            "cannotBeAblenker": false,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/0d423a7d-ce8a-4136-a002-cab2d617178f.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/79b65006-d8fb-4631-bac7-04c3ef1ce4c1.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/cbd743f1-38dd-426b-a15c-6bc09345e293.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/5ed7433f-fbc5-4f98-9645-c0e428d38f88.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/428c364c-e8fd-47fc-ac7d-90421dba6a73.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1bcd99c9-9051-4e46-af75-b200242bf06b.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/3c23926e-73b4-40ca-883a-c960131fb378.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/272c9a51-5ee3-470b-a9cc-809b42ca87cc.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/35931570-7aef-4fd1-ae3f-438b27e71768.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/e24192fd-5dfd-4dff-9b38-5fad8686c1e6.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/74d67fda-2981-487c-bae5-e9bf7bc94751.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 9,
            "created": "2016-10-25T11:04:41.494Z",
            "grapheme": "akku-universalschneider",
            "print": "Akku-Universalschneider",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/3f23449a-70e1-41be-a96d-d2b6150f6e27.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/cf0911b0-6513-46ca-ac9d-5c71bfa3bf9f.mp4",
            "cannotBeAblenker": true,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/3f23449a-70e1-41be-a96d-d2b6150f6e27.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/34421eea-ae45-4444-b7b3-dd86b8458b57.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1e886423-2b96-4f20-8502-7c0c53a0cca8.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/43114f50-8335-4839-b02a-afeb70349c11.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/71c2fd35-7ab4-4b83-85a2-017a0ac5b73c.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/00865ace-8484-477c-afef-adb01309c4a7.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/94afdaa8-76af-4cf5-b0b7-10f5fbb520a3.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/4ca8ce6f-4c58-44e2-868d-52d8d7b5744f.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/bbe593c6-fa0d-47e1-9dbb-a866648e3764.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/e2d0d508-4282-45ef-bab6-bb58c463461c.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/9aee27d2-982b-4d49-8920-5d7d6c7182e0.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 6,
            "created": "2016-10-25T11:08:55.218Z",
            "grapheme": "eis",
            "print": "Eis",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/49c0eab0-b1c3-4354-ac63-2daa4f2eaccb.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/7abf480e-a058-4722-82b1-182e4f0f229d.mp4",
            "cannotBeAblenker": false,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/49c0eab0-b1c3-4354-ac63-2daa4f2eaccb.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/56c8b2b5-9f90-4a9b-bac8-3da38538aa9a.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/b7d3146d-70a8-4a50-9c81-7813d9f801e8.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/c88141ab-26eb-48f8-910f-733c2c0a3b50.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/6a884200-f49d-4436-9350-0bfc73889d60.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/7931dd14-8c3d-4d84-9fe1-514e2a91047d.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/55b3a4db-fe59-4a68-8b9e-7e35753c92ea.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/a1727b95-aed1-4856-8416-10c14fcc01c1.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/9ddbf92c-7938-4bef-b195-cb50ad7722c9.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/7192102f-d09a-4b96-b2b0-8fb725297ac2.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/6f8265c8-1d18-4b25-a69b-66bde53dc82a.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 6,
            "created": "2016-10-25T11:12:09.048Z",
            "grapheme": "hai",
            "print": "Hai",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/6bc73040-e544-460e-911b-88b2da1ebdc6.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/c6cb739b-1468-4afc-a00f-72f28fe01580.mp4",
            "cannotBeAblenker": false,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/6bc73040-e544-460e-911b-88b2da1ebdc6.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0a3de373-bca4-4ce3-9c4c-b76833155caa.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1e4d9ee0-ac3c-4de7-9e63-e05a70b50c19.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/fd5a1bcb-0e9a-4fdb-93b8-d8689f9cc0c8.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0790f662-1862-4f78-b6ff-9d87ff92c636.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/732e96ae-af20-4246-a053-31c3466a6b6b.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/fd903d09-103b-4404-8a95-5411ed213e4d.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/3cd39b72-a124-4f4f-bcd9-d1bc728491dd.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0998583d-c0ad-4761-9d0a-bc259f33bdc6.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/48c49e36-4ad8-42b8-8ca7-08a13d686977.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/e8c49830-87db-4901-b83f-67f21fb309dd.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 8,
            "created": "2016-10-25T11:21:54.476Z",
            "grapheme": "schuh",
            "print": "Schuh",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/a08c5645-8fee-4f13-ad70-a4ba60762006.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/c5ada130-9064-43df-88fb-dc4a71b4c68a.mp4",
            "cannotBeAblenker": false,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/a08c5645-8fee-4f13-ad70-a4ba60762006.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/ef2f235a-82c1-4b2b-84d0-1bfa804a2a5e.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d2a4e522-5677-4595-92bc-544e73317977.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/bf8e5a4d-7bcf-4d59-abce-0a70425054af.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/77511606-a775-41fe-8323-14be900cb494.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/35670657-4b70-4209-ab9f-527b4b937967.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1cc5bef4-5505-479c-9477-e21b3e7d9a9d.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/7d0ae930-b07b-441a-a544-499fef90a22b.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/405c8ba2-971e-42e2-84ab-7b5bf5a5a83b.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/9cb6c03b-2e57-4f26-bde4-be9773113f03.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/5454c4b5-1202-4f60-8d0d-0160e7f055e8.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 7,
            "created": "2016-10-25T11:06:35.862Z",
            "grapheme": "bett",
            "print": "Bett",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/10569612-c73a-4428-9f32-118264ab5651.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/655b2752-6a3c-4f81-86fe-2a01c7791ca5.mp4",
            "cannotBeAblenker": true,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/10569612-c73a-4428-9f32-118264ab5651.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/514df3b0-6854-45be-8a27-50e785ab4579.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/b437468f-560b-4fef-b3d8-a18603cbf821.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/f4d22550-9269-4362-97b3-ba6f2ccd2972.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/a88df068-1610-43e1-9be2-4880fa1e6323.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1146d7b2-4951-44fb-921f-59431519a2b1.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/196a580c-a1a8-49f7-89ff-83dff082ba5a.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/f97d9995-7573-4c71-95aa-13928ec44c3f.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/9c8a014d-a203-499a-808b-d69114433730.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/db59ef24-a904-47e2-a145-3bbad4c09edf.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d78efc1c-cd41-4699-a1bd-9c03927ee661.jpg"
          ]
        }
      ],
      "_id": "",
      "__v": 25,
      "createdAt": "2017-02-25T08:38:38.000Z",
      "updatedAt": "2019-07-16T13:50:31.614Z",
      "appDisplayName": "Kurze Wörter"
    },
    {
      "type": "sentenceset",
      "setItems": [
        {
          "_id": "",
          "__v": 0,
          "sentence": {
            "_id": "",
            "__v": 2,
            "created": "2018-10-18T17:39:47.862Z",
            "grapheme": "der junge mäht den rasen",
            "print": "Der Junge mäht den Rasen",
            "optionalWrongWords": ["Die", "Frau", "zeichnet", "Skizzen"],
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0fa6769f-27b6-4d7c-9e7a-e52027f47cbf.jpg"
            ],
            "audio": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_audiomp3/production/deutsch/audios/dfae2032-788a-4624-b232-062fbe57d540.mp3",
            "cannotBeAblenker": false
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d0e38815-8e93-42c8-9800-140e44cc8f0a.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/681b6dce-cc45-49a4-a100-396af3ce4231.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/664d66b8-da2d-470b-92aa-28cf88bbc1ad.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/3a378328-0a9f-4996-a57b-937eb2ca3c2f.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d2f0db3b-ec7b-4d59-a090-8da0a3b9e394.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/c126bd66-3545-46d0-afc0-62162dfc0a07.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/5de94693-3151-4919-a66f-ba279b795493.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/fb873bdd-b3f3-47a4-a610-3a5ada0d4b92.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "sentence": {
            "_id": "",
            "__v": 2,
            "created": "2018-10-18T17:39:47.749Z",
            "grapheme": "die frau liest im garten",
            "print": "Die Frau liest im Garten",
            "optionalWrongWords": ["Der", "Junge", "schaut", "Fernsehen"],
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/9ba5fa60-8e20-4974-acda-181a26248a3c.jpg"
            ],
            "audio": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_audiomp3/production/deutsch/audios/fd40a9ce-73cc-469d-be35-5cb52c3920e4.mp3",
            "cannotBeAblenker": false
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/8d463149-591e-4cd9-a9f4-4ceed78cb658.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/7c93822a-38cf-444e-a2c3-f8f1f781752c.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/77414b0a-37b1-49da-85b8-a3531735487e.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/f6805446-ef62-421f-98bd-a6a22175f307.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/296239b2-6d62-4726-b596-653d8255090c.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/08421917-04af-416c-99fa-193c09c4943e.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/2888e5c2-4de9-422a-aa1d-ab6ad929e953.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/5de94693-3151-4919-a66f-ba279b795493.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "sentence": {
            "_id": "",
            "__v": 2,
            "created": "2018-10-18T17:39:47.170Z",
            "grapheme": "das mädchen gießt die blumen",
            "print": "Das Mädchen gießt die Blumen",
            "optionalWrongWords": ["Der", "Junge", "jagt", "Tauben"],
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/fa1eee5c-8df9-4d42-8362-836f28682cf8.jpg"
            ],
            "audio": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_audiomp3/production/deutsch/audios/0931fc2d-8577-4842-96c3-36e5751d6ab9.mp3",
            "cannotBeAblenker": false
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/c4d0ca04-f93d-4af7-bdf1-22f7613a6740.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/ee4fe465-1aa5-4d09-b5a2-612934099a47.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/29fd00bc-1d47-4e2c-b960-9164f3cf3328.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/cd6d7a28-8e28-4e9d-9131-06545b391955.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/5c7eca2c-5a4d-4d79-ba7e-8b2a45d39f99.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/31424c83-477a-4cdb-a717-4be22fff920e.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/20d6b229-859d-4c1a-8694-a42f22b4cf33.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/ac92f122-2570-4f36-9a15-b271c6ea0dbf.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "sentence": {
            "_id": "",
            "__v": 2,
            "created": "2018-10-18T17:39:46.555Z",
            "grapheme": "der mann erntet tomaten",
            "print": "Der Mann erntet Tomaten",
            "optionalWrongWords": ["Das", "Mädchen", "feilt", "Nägel"],
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d7fa6b1d-7800-4a40-a641-720e81e14bd9.jpg"
            ],
            "audio": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_audiomp3/production/deutsch/audios/ad2bc15d-8b37-4355-b6fd-a6d2a4b10686.mp3",
            "cannotBeAblenker": false
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/aeb7da10-edb3-4faf-acf1-c89ca47dcf97.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/b224eb23-f314-4397-8888-fa62eada9aa7.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/76aca3c6-cf2a-4524-b0c9-b4e3a69b515b.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/49dcd32c-f97b-46fd-84ba-074a05a96ea3.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/5ccb0dcb-cf3d-4965-966f-08a87f374958.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/2e7fac3c-7778-42be-9b41-87b2e11a9861.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/4bdf27d6-7969-412e-886f-ed90d98f86b4.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/ebf7b793-aa60-4c96-ada5-795d791a2e55.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "sentence": {
            "_id": "",
            "__v": 2,
            "created": "2018-10-18T17:39:45.876Z",
            "grapheme": "der mann bepflanzt den garten",
            "print": "Der Mann bepflanzt den Garten",
            "optionalWrongWords": ["Das", "Mädchen", "bemalt", "Stoff"],
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/aeb7da10-edb3-4faf-acf1-c89ca47dcf97.jpg"
            ],
            "audio": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_audiomp3/production/deutsch/audios/9198aff7-eb0d-4e92-94be-e237ee9f7b2e.mp3",
            "cannotBeAblenker": false
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/2128a493-dd03-4fd0-a61e-6705c954b46c.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d7fa6b1d-7800-4a40-a641-720e81e14bd9.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/59d3248b-f860-422c-b64d-3e11666d5cf5.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/517c6e64-9ec8-4113-b042-c590a3105b5a.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/79b00bf9-943f-4b4f-8e7b-6fba1f949cb9.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/77ff432c-01b1-46e0-9855-426289bc93cf.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/075fdca0-5eb3-4316-839b-c25647d6ea90.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d4f7353e-4c20-4584-89cf-05f16029f628.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "sentence": {
            "_id": "",
            "__v": 2,
            "created": "2018-10-18T17:39:48.694Z",
            "grapheme": "die frau schneidet die hecke",
            "print": "Die Frau schneidet die Hecke",
            "optionalWrongWords": ["Der", "Junge", "gewinnt", "Luftballons"],
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/4c439e9c-9528-4413-8a1f-188b35541307.jpg"
            ],
            "audio": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_audiomp3/production/deutsch/audios/4240c9f1-9f12-4a78-a2b6-894661ab87e4.mp3",
            "cannotBeAblenker": false
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/c4d0ca04-f93d-4af7-bdf1-22f7613a6740.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/31168f80-4f5f-431c-a0f9-c8ba425d3a10.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/6483bd59-5438-4bf4-a0c2-b0cf6b9c9486.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/218c3de6-7141-4a5a-8e5b-435d668c851b.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/b3c53ffc-8051-4a61-9ad4-6f7bfc913ec5.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/e64afaae-b2c3-40eb-a23d-5e21b7e71611.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1da26204-2f37-4e36-83c7-d699209609b0.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/59ffc894-35cf-41bd-ab27-fded2dff9ae6.jpg"
          ]
        }
      ],
      "_id": "",
      "__v": 25,
      "createdAt": "2017-02-25T08:38:38.000Z",
      "updatedAt": "2019-07-16T13:50:31.614Z",
      "appDisplayName": "Sätze"
    },
    {
      "type": "textset",
      "setItems": [
        {
          "_id": "",
          "__v": 0,
          "type": "word",
          "word": {
            "_id": "",
            "__v": 6,
            "created": "2016-10-25T11:08:43.954Z",
            "grapheme": "ei",
            "print": "Ei",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0d423a7d-ce8a-4136-a002-cab2d617178f.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/f35ab5fe-aaeb-42ed-91e2-bf90647e6799.mp4",
            "cannotBeAblenker": false,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/0d423a7d-ce8a-4136-a002-cab2d617178f.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/79b65006-d8fb-4631-bac7-04c3ef1ce4c1.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/cbd743f1-38dd-426b-a15c-6bc09345e293.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/5ed7433f-fbc5-4f98-9645-c0e428d38f88.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/428c364c-e8fd-47fc-ac7d-90421dba6a73.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1bcd99c9-9051-4e46-af75-b200242bf06b.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/3c23926e-73b4-40ca-883a-c960131fb378.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/272c9a51-5ee3-470b-a9cc-809b42ca87cc.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/35931570-7aef-4fd1-ae3f-438b27e71768.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/e24192fd-5dfd-4dff-9b38-5fad8686c1e6.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/74d67fda-2981-487c-bae5-e9bf7bc94751.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 6,
            "created": "2016-10-25T11:08:55.218Z",
            "grapheme": "eis",
            "print": "Eis",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/49c0eab0-b1c3-4354-ac63-2daa4f2eaccb.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/7abf480e-a058-4722-82b1-182e4f0f229d.mp4",
            "cannotBeAblenker": false,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/49c0eab0-b1c3-4354-ac63-2daa4f2eaccb.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/56c8b2b5-9f90-4a9b-bac8-3da38538aa9a.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/b7d3146d-70a8-4a50-9c81-7813d9f801e8.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/c88141ab-26eb-48f8-910f-733c2c0a3b50.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/6a884200-f49d-4436-9350-0bfc73889d60.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/7931dd14-8c3d-4d84-9fe1-514e2a91047d.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/55b3a4db-fe59-4a68-8b9e-7e35753c92ea.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/a1727b95-aed1-4856-8416-10c14fcc01c1.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/9ddbf92c-7938-4bef-b195-cb50ad7722c9.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/7192102f-d09a-4b96-b2b0-8fb725297ac2.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/6f8265c8-1d18-4b25-a69b-66bde53dc82a.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 6,
            "created": "2016-10-25T11:12:09.048Z",
            "grapheme": "hai",
            "print": "Hai",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/6bc73040-e544-460e-911b-88b2da1ebdc6.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/c6cb739b-1468-4afc-a00f-72f28fe01580.mp4",
            "cannotBeAblenker": false,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/6bc73040-e544-460e-911b-88b2da1ebdc6.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0a3de373-bca4-4ce3-9c4c-b76833155caa.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1e4d9ee0-ac3c-4de7-9e63-e05a70b50c19.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/fd5a1bcb-0e9a-4fdb-93b8-d8689f9cc0c8.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0790f662-1862-4f78-b6ff-9d87ff92c636.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/732e96ae-af20-4246-a053-31c3466a6b6b.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/fd903d09-103b-4404-8a95-5411ed213e4d.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/3cd39b72-a124-4f4f-bcd9-d1bc728491dd.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/0998583d-c0ad-4761-9d0a-bc259f33bdc6.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/48c49e36-4ad8-42b8-8ca7-08a13d686977.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/e8c49830-87db-4901-b83f-67f21fb309dd.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 8,
            "created": "2016-10-25T11:21:54.476Z",
            "grapheme": "schuh",
            "print": "Schuh",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/a08c5645-8fee-4f13-ad70-a4ba60762006.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/c5ada130-9064-43df-88fb-dc4a71b4c68a.mp4",
            "cannotBeAblenker": false,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/a08c5645-8fee-4f13-ad70-a4ba60762006.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/ef2f235a-82c1-4b2b-84d0-1bfa804a2a5e.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d2a4e522-5677-4595-92bc-544e73317977.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/bf8e5a4d-7bcf-4d59-abce-0a70425054af.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/77511606-a775-41fe-8323-14be900cb494.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/35670657-4b70-4209-ab9f-527b4b937967.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1cc5bef4-5505-479c-9477-e21b3e7d9a9d.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/7d0ae930-b07b-441a-a544-499fef90a22b.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/405c8ba2-971e-42e2-84ab-7b5bf5a5a83b.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/9cb6c03b-2e57-4f26-bde4-be9773113f03.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/5454c4b5-1202-4f60-8d0d-0160e7f055e8.jpg"
          ]
        },
        {
          "_id": "",
          "__v": 0,
          "word": {
            "_id": "",
            "__v": 7,
            "created": "2016-10-25T11:06:35.862Z",
            "grapheme": "bett",
            "print": "Bett",
            "partsOfSpeech": "nomen",
            "pictures": [
              "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/10569612-c73a-4428-9f32-118264ab5651.jpg"
            ],
            "video": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/video/private/t_original/production/deutsch/videos/655b2752-6a3c-4f81-86fe-2a01c7791ca5.mp4",
            "cannotBeAblenker": true,
            "retinaImage": "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_original/production/deutsch/images/10569612-c73a-4428-9f32-118264ab5651.jpg"
          },
          "semanticPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/514df3b0-6854-45be-8a27-50e785ab4579.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/b437468f-560b-4fef-b3d8-a18603cbf821.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/f4d22550-9269-4362-97b3-ba6f2ccd2972.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/a88df068-1610-43e1-9be2-4880fa1e6323.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/1146d7b2-4951-44fb-921f-59431519a2b1.jpg"
          ],
          "unrelatedPictures": [
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/196a580c-a1a8-49f7-89ff-83dff082ba5a.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/f97d9995-7573-4c71-95aa-13928ec44c3f.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/9c8a014d-a203-499a-808b-d69114433730.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/db59ef24-a904-47e2-a145-3bbad4c09edf.jpg",
            "https://neolexon-assets.obs-website.eu-de.otc.t-systems.com/neolexon/image/private/t_appimage/production/deutsch/images/d78efc1c-cd41-4699-a1bd-9c03927ee661.jpg"
          ]
        }
      ],
      "_id": "",
      "__v": 25,
      "createdAt": "2017-02-25T08:38:38.000Z",
      "updatedAt": "2019-07-16T13:50:31.614Z",
      "appDisplayName": "Texte (not finished)"
    }
  ]
}
